import { GoogleLogin, CredentialResponse } from "@react-oauth/google";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import { 
  Box, 
  Container, 
  CircularProgress, 
  Alert, 
  Typography, 
  Paper, 
  useTheme,
  CssBaseline,
  Avatar,
  useMediaQuery
} from "@mui/material";
import { useState } from "react";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleGoogleSuccess = async (response: CredentialResponse) => {
    if (!response.credential) {
      setError("No se recibieron credenciales de Google");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      await login(response.credential);
      navigate("/");
    } catch (err) {
      console.error("Error en el login:", err);
      setError("Error al iniciar sesión. Por favor intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h4" sx={{ mb: 2, fontWeight: 'bold' }}>
          Iniciar sesión
        </Typography>
        
        <Paper elevation={3} sx={{ 
          p: 4, 
          width: '100%', 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          borderRadius: 2
        }}>
          <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 3 }}>
            Registrate para guardar tus lugares favoritos y acceder a beneficios especiales.
          </Typography>

          {error && (
            <Alert severity="error" sx={{ width: '100%', mb: 3 }}>
              {error}
            </Alert>
          )}

          {loading ? (
            <CircularProgress size={40} sx={{ my: 2 }} />
          ) : (
            <Box sx={{ 
              width: '100%', 
              display: 'flex', 
              justifyContent: 'center',
              '& .MuiButton-root': {
                width: isSmallScreen ? '100%' : 'auto',
                height: 42,
                borderRadius: 1
              }
            }}>
              <GoogleLogin 
                onSuccess={handleGoogleSuccess} 
                onError={() => {
                  setError("Error de autenticación con Google");
                  console.error("Error de autenticación");
                }}
                theme="filled_blue"
                size="large"
                text="continue_with"
                shape="pill"
              />
            </Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;